import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAdminAuth } from '../context/AdminAuthContext';

const AdminLogin = () => {
  const { login } = useAdminAuth();
  const navigate = useNavigate();

  const [form, setForm] = useState({ username: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [showPass, setShowPass] = useState(false);

  const handleChange = (e) => {
    setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));
    setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.username.trim() || !form.password.trim()) {
      setError('Please enter username and password.');
      return;
    }
    setLoading(true);
    try {
      await login(form.username.trim(), form.password.trim());
      navigate('/admin/dashboard', { replace: true });
    } catch (err) {
      setError(err.message || 'Login failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-login-page">
      <div className="admin-login-deco admin-login-deco-tr" aria-hidden="true"></div>
      <div className="admin-login-deco admin-login-deco-bl" aria-hidden="true"></div>

      <div className="admin-login-wrap">
        <div className="admin-login-card">
          <div className="admin-login-brand">
            <img src="/logo.jpg" alt="Shree Ram Ranuja Dham" className="admin-login-logo" />
            <h1 className="admin-login-title">Shree Ram Ranuja Dham</h1>
          </div>

          {error && (
            <div className="admin-login-error">
              <i className="fas fa-exclamation-circle"></i>
              <span>{error}</span>
            </div>
          )}

          <form onSubmit={handleSubmit} className="admin-login-form" autoComplete="off">
            <div>
              <label className="admin-login-label" htmlFor="admin-username">Username</label>
              <div className="admin-login-field">
                <span className="admin-login-icon-wrap" aria-hidden="true">
                  <i className="fas fa-user"></i>
                </span>
                <input
                  id="admin-username"
                  type="search"
                  inputMode="text"
                  name="username"
                  value={form.username}
                  onChange={handleChange}
                  placeholder="Enter username"
                  autoComplete="off"
                  autoCapitalize="off"
                  autoCorrect="off"
                  spellCheck={false}
                  className="admin-login-input"
                />
              </div>
            </div>

            <div>
              <label className="admin-login-label" htmlFor="admin-password">Password</label>
              <div className="admin-login-field">
                <span className="admin-login-icon-wrap" aria-hidden="true">
                  <i className="fas fa-lock"></i>
                </span>
                <input
                  id="admin-password"
                  type={showPass ? 'text' : 'password'}
                  name="password"
                  value={form.password}
                  onChange={handleChange}
                  placeholder="Enter password"
                  autoComplete="off"
                  autoCapitalize="off"
                  autoCorrect="off"
                  spellCheck={false}
                  className="admin-login-input admin-login-input-pass"
                />
                <button
                  type="button"
                  onClick={() => setShowPass((p) => !p)}
                  className="admin-login-toggle"
                  tabIndex={-1}
                  aria-label={showPass ? 'Hide password' : 'Show password'}
                >
                  <i className={`fas ${showPass ? 'fa-eye-slash' : 'fa-eye'}`}></i>
                </button>
              </div>
            </div>

            <button
              type="submit"
              disabled={loading}
              className="admin-btn-primary admin-login-submit"
            >
              {loading ? (
                <>
                  <i className="fas fa-spinner fa-spin"></i>
                  Signing in...
                </>
              ) : (
                <>
                  <i className="fas fa-sign-in-alt"></i>
                  Sign In
                </>
              )}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;
